import styled, { css } from "styled-components";
import { FooterButtonProps } from "./FooterButton";

interface FooterButtonElementProps {
  buttonType: FooterButtonProps['buttonType'];
}

const handleButtonType = (buttonType: FooterButtonProps['buttonType']) => {
  switch (buttonType) {
    case 'back':
      return css`
        color: #1C344F;
        background-color: white;
        border: 1px solid #1C344F;
      `;
    case 'next':
      return css`
        color: white;
        font-weight: 700;
        width: 210px;
        background-color: #1AC876;
      `;
    case 'done':
      return css`
        color: white;
        background-color: #1AC876;
      `;
    default:
      return css`
        color: white;
        background-color: #1C344F;
      `;
  }
};

export const StandardButton = styled.button`
    border: none;
    border-radius: 3px;
    cursor: pointer;
    
    &:hover{
      opacity: 0.8;
    };

    &:disabled{
      opacity: 0.5;
      pointer-events: none;
    };
`;

export const FooterButtonElement = styled(StandardButton)<FooterButtonElementProps>`
  font-size: 15px;
  width: 150px;
  height: 40px;
  outline: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;

  ${({ buttonType }) => handleButtonType(buttonType)}
`;
